const logout = () => {    
    return fetch(`/routes/api/sessions/logout/`, {
        method: "POST",
        credentials: "include",
    })
    .then(res => {
        return res.json();
    })
    .then(data => {
        if(data?.type && data?.type === "switch") {
            return "switch";
        }

        return true;
    })
    .catch(err => {
        // if(localStorage.getItem("eduheroAccessToken")){
        //     localStorage.removeItem("eduheroAccessToken");
        // }
        return false;
    });
};

export default logout;